import "react";
import "@mui/material";
import "@mui/x-data-grid";
import "uuid";
import "../../../components/alerts/InfoMessage.js";
import "../../../components/alerts/NoAccessInfoMessage.js";
import "../../../components/alerts/Message.style.js";
import "react-intl";
import "../../../components/alerts/InfoAlert.js";
import "../../../components/alerts/InfoMessageHoc.js";
import "../../../components/checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../../components/pagination/StyledPagination.js";
import "../../../components/data-grid/mui/GridColumnsButton.js";
import "../../../components/data-grid/mui/GridColumnsPanel.js";
import "../../../components/data-grid/mui/hooks/useGridCellStyle.js";
import "../../../components/data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../../components/data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../../components/data-grid/mui/cells/InvalidDataCell.js";
import { withDataGridEntityClient } from "../../../components/data-grid/mui/DataGridEntity.js";
import { MuiDataGridClient } from "../../../components/data-grid/mui/MuiDataGridClient.js";
import "../../../components/data-grid/mui/cells/CurrencyCell.js";
import "../../../components/data-grid/mui/cells/DateCell.js";
import "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import "../../../components/tooltip/Tooltip.js";
import "moment-timezone";
import "../../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "../../../components/data-grid/mui/cells/LabelsCell.js";
import "../../../components/data-grid/mui/cells/NumberCell.js";
import "../../../components/data-grid/mui/cells/TextCell.js";
import "../../../components/link/LinkHOC.js";
import "../../../components/link/LinkButton.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../../components/data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../../components/data-grid/mui/cells/DurationCell.js";
import "../../../components/data-grid/mui/cells/PercentCell.js";
import "../../../components/modal/BulkModalContent.js";
import "../../../components/modal/BulkModalProvider.js";
import "../../../components/modal/ModalButtons.js";
import "../../../components/modal/Modal.style.js";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/error/ErrorAccordion.js";
import "../../../components/error/ErrorDetails.js";
import "../../../components/error/localize.js";
import "../../../components/error/ErrorModal.js";
import "../../../components/error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../../components/modal/types.js";
import "../../../components/modal/ActionConfirmationModal.js";
import "../../../components/data-grid/mui/cells/ButtonCell.js";
import "@apollo/client";
import "rxjs";
import "../../../api/types.js";
import "@apollo/client/errors";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "@automapper/core";
import "date-fns";
import "../../user-profile/constants.js";
import "react-redux";
import "../../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../../auto-mapper/AutoMapperProvider.js";
import "../../../redux-folder/async-actions/actions.js";
import "../../../redux-folder/async-actions/selectors.js";
import "../../../intl/shared-resources/serverResponse.js";
import "typesafe-actions";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "../../../redux-folder/async-actions/reducers.js";
import "../../../redux-folder/download/actions.js";
import "../../../redux-folder/download/epics.js";
import "../../../ioc-container/inversifyProvider.js";
import "react-hook-form";
import "normalizr";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "../../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import { DataGridUserProfileConfigFactory } from "../../user-profile/components/DataGrid.js";
import "../../user-profile/actions.js";
import "../../user-profile/epics.js";
import "../../user-profile/components/Platform.js";
import "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import "../../../components/filter/FilterGroupNew.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../../components/select/Select.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import "../../brand-license/constants.js";
import "../../country/components/CountryFilter.js";
import "../../brand-license/components/BrandProvider.js";
import "../../brand-license/components/LicenseSelect.js";
import "../../brand-license/components/BrandSelect.js";
import "../../../components/circle-box/CircleBoxWithText.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../../style/hooks.js";
import "../../../components/circle-box/CircleBox.js";
import "../../user-profile/components/Filters.js";
import "../../user-profile/components/P2PStatusCell.js";
import "../../user-profile/components/UserDetailsWDBalance.js";
import "../../user-profile/components/ReferralLinkButton.js";
import "../../user-profile/components/PlayerIdAutocomplete.js";
import { DataGridTransactionConfigFactory } from "./DataGrid.js";
import { DataGridTransactionEditableConfigFactory } from "./DataGridEditable.js";
const DataGridTransactionWithUserProfileEditableClient = withDataGridEntityClient(MuiDataGridClient, () => ({
  ...new DataGridUserProfileConfigFactory().getColumnConfig(),
  ...new DataGridTransactionConfigFactory().getColumnConfig(),
  ...new DataGridTransactionEditableConfigFactory().getColumnConfig()
}));
export {
  DataGridTransactionWithUserProfileEditableClient
};
//# sourceMappingURL=DataGridWithUserProfileEditable.js.map
